import React from "react";

/**
 * OpenEstimate logomark — inline SVG, colour-adaptable.
 *
 * viewBox 0 0 256 120  (canonical design-system proportions, ~2.13:1)
 *   Circle O: cx=60  cy=60  r=40  stroke-width=16
 *   Bar top:  x=132  y=16   w=72  h=16
 *   Bar mid:  x=132  y=52   w=60  h=16   (≈83% width)
 *   Bar bot:  x=132  y=88   w=72  h=16
 *
 * Props:
 *   height      — scales the mark; width auto-derives from 2.13:1 ratio
 *   color       — fallback for both parts (defaults to currentColor)
 *   circleColor — override stroke colour for the O ring (e.g. "white" on dark bg)
 *   barColor    — override fill colour for the E bars (e.g. teal accent)
 *   style       — extra inline styles on <svg>
 */
const OELogo = ({
  height = 32,
  color = "currentColor",
  circleColor,
  barColor,
  style,
}: {
  height?: number;
  color?: string;
  circleColor?: string;
  barColor?: string;
  style?: React.CSSProperties;
}) => {
  const w = Math.round(height * (256 / 120));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={height}
      viewBox="0 0 256 120"
      fill="none"
      aria-label="OpenEstimate"
      style={{ display: "block", flexShrink: 0, ...style }}
    >
      {/* O — circle ring */}
      <circle cx="60" cy="60" r="40" fill="none" stroke={circleColor ?? color} strokeWidth="16" />
      {/* E — three horizontal bars */}
      <g fill={barColor ?? color}>
        <rect x="132" y="16"  width="72" height="16" />
        <rect x="132" y="52"  width="60" height="16" />
        <rect x="132" y="88"  width="72" height="16" />
      </g>
    </svg>
  );
};

export default OELogo;
